export const SetPasswordController = ($scope,
                                       $mdDialog,
                                       callback,
                                       title,
                                       password
) => {
    "ngInject";

    $scope.callback = callback;
    $scope.title = title;
    $scope.password = password || null;


    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.set = () => {
        callback($scope.password);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.password && $scope.password.length >= 7) {
                $scope.create();
            }
        }
    };
};


// WEBPACK FOOTER //
// ./sources/components/booths/set-password/set-password.js